import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Skeleton } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  chartContainer: {
    margin: theme.spacing(1),
    height: theme.spacing(8),
    overflow: 'hidden',
    backgroundColor: theme.skelton.color,
    borderRadius: theme.spacing(0.5)
  }
}));

const TeamProductivitySkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid container data-testid="team-productivity-skeleton-container">
      <Grid container item xs={12} className={classes.chartContainer}>
        <Skeleton height="70%" variant="rectangular" />
      </Grid>
    </Grid>
  );
};

export default React.memo(TeamProductivitySkeleton);
